import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Banner } from "../../shared/models/banner";
import { TranslateService } from "@ngx-translate/core";
import { DTFService } from "../../dtf.service";
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service';
import { WindowRef } from '../../utils/window';

import { MatDialog } from "@angular/material/dialog";
import { CookiesPopupComponent } from "../cookiesPopup/cookiesPopupDialog.component";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatPaginator } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { SharedTranslateModule } from "../../utils/sharedTranslateModule";
import { PasswordResetConfirmComponent } from "../passwordresetconfirm/passwordresetconfirm.component";
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { RegistrationConfirmComponent } from "../registrationConfirm/registrationConfirm.component";
import { SessionTimeoutComponent } from "../sessionTimeout/sessionTimeout.component";
@Component({
    selector: "div.dtfca-homepage",
    imports: [SharedTranslateModule, PasswordResetConfirmComponent, RegistrationConfirmComponent,
        MatTableModule, MatCheckboxModule, MatFormFieldModule,SessionTimeoutComponent,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, NgbCarouselModule, MatSortModule
    ],
    templateUrl: "./dtfcahomepage.component.html",
    providers: []
})
export class DTFCAHomeComponent implements OnInit {
title = "Content Section of the Page";
router: Router;
public alerts: Banner;
public alertsCopy: Banner;
language = '';
dbData: any;
displayStatic: boolean = false;
dbCopy: any;
public sliders: Array<Banner> = [];
toggleOpen: any;
private _window: WindowRef;
position1 = 'top';
position2 = 'mid';
position3 = 'bot';
myInterval = 10000; // Carousel Rotate Speed
passwordResetFlag = false;
RegistrationConfirmFlag=false;
RegistrationPopup = false;
showPopup='';
showVideo = false;
usUrl: string;
videoredirect = '';
langFlag: string;


divStyle = '';

constructor(
  router: Router,
  public translate: TranslateService,
  public dtfhomepageService: DTFHomepageService,
  window: WindowRef,
  private dtfservice: DTFService,
  public dialog: MatDialog
) {
  this.router = router;
  this._window = window;
  this.dbData = false;
  this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
  this.getAlerts();
}
ngOnInit() {
  this.divStyle = '/static/assets/img/dtf-assets/images/redesign/mbfs_top_image_and_tint.jpg';
  this.language = (this._window.nativeWindow as any).mbfs.language;
  const language = (window as any).mbfs.language;
  this.langFlag = language;

  const passwordreset = (this._window.nativeWindow as any).mbfs.passwordreset;
  if(passwordreset !=""){
    this.checkPassword();
  }
  
  const registrationConfirm = (this._window.nativeWindow as any).mbfs.registrationConfirm;
  if(registrationConfirm !=""){
    this.checkRegistrationConfirm();
  }
  if(localStorage.getItem('enableGA')){
    this.showPopup = localStorage.getItem('enableGA');
}
  const disableGA  = (this._window.nativeWindow as any).mbfs.disableGA;
  if(disableGA ===""){
    if(passwordreset ===""){
      if(registrationConfirm ===""){
        if(this.showPopup!='yes'){
          this.openDialog();
        }
      }
    }
  }
  const registrationPopup = (this._window.nativeWindow as any).mbfs.registrationPopup;
  if(registrationPopup !=""){
    this.checkRegistrationPopup();
  }
}
anouncementMgsopen(e: any) {
  e.preventDefault();
  if (this.toggleOpen) {
    this.toggleOpen = false;
  } else {
    this.toggleOpen = true;
  }
}

getAlerts() {
  this.dtfhomepageService.getAlerts().subscribe((res) => {
    for (var i = 0; i < res.length; i++) {
        //Checks if type is banner and if the naming convention contains language( en-CA) + -Banner
      if (res[i].bannerType === 'Banner' &&  res[i].bannerName.indexOf((this.language)) !== -1
          && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'CA') {
        this.sliders.push(res[i]);        
      }
    }
    if (!this.sliders?.length) {this.displayStatic = true;} //Turns on Static page if no banners are pulled
  });
}

isBlank(str) {
  return (!str || /^\s*$/.test(str));
}

checkPassword(){
  this.passwordResetFlag=true;
}
checkRegistrationConfirm(){
  this.RegistrationConfirmFlag=true;
}

checkRegistrationPopup(){
  this.RegistrationPopup=true;
}

openDialog() {
  this.dialog.open(CookiesPopupComponent, {
    maxWidth: '100%',
    width: '100%',
    disableClose: true
});
}

  clickvideo(redirect: string){
   
  sessionStorage.removeItem('videoRedirect');
  this.showVideo = false;

    if(redirect === "mainnav"){
      if(this.langFlag === 'fr-CA'){
        this.videoredirect = this.usUrl + "/static/videos/DTFWebsite-RegistrationCAFrench.mp4";
        
        sessionStorage.setItem('videoRedirect', this.videoredirect);
        let azURL =  this.usUrl + '/ca/fr/home/video';

        setTimeout(() => {
          window.open(azURL, '_blank', 'width=1200, height=900');
        }, 500);  //1s
      }
      else{
        this.videoredirect = this.usUrl + "/static/videos/DTFWebsite-RegistrationCAEnglish.mp4";

        sessionStorage.setItem('videoRedirect', this.videoredirect);
        let azURL =  this.usUrl + '/ca/en/home/video';
    
        setTimeout(() => {
          window.open(azURL, '_blank', 'width=1200, height=900');
        }, 500);  //1s
      }
    }
  }
}
